import { reuseMesh as reuseBuildMesh } from 'trace-viewer/build';
import type { ToolContext } from '../agent-helpers';
import { resolveUniqueByName } from '../agent-helpers';

/** Resolve tool transport refs; the shared engine assigns the persisted baked asset. */
export async function reuseMesh(input: Record<string, unknown>, ctx: ToolContext): Promise<string> {
    try {
        if (typeof input.source !== 'string' || !input.source.trim()) throw new Error('source must name an existing baked mesh object.');
        const refs = input.objects;
        if (!Array.isArray(refs) || !refs.length || refs.length > 128 || refs.some(ref => typeof ref !== 'string' || !ref.trim())) {
            throw new Error('objects must contain 1–128 existing object names/paths.');
        }
        const source = resolveUniqueByName(ctx.traceScene, input.source, 'mesh source');
        const targets = [...new Set(refs.map(ref => resolveUniqueByName(ctx.traceScene, ref as string, 'mesh target')))];
        return await reuseBuildMesh(source, targets, {
            assignSource: async (object, src) => {
                if (ctx.viewer?.import) await object.setSrc(src);
                else object._setSrcInternal(src);
            },
            onSceneChanged: ctx.onSceneChanged,
        });
    } catch (error) {
        return `Error: ${error instanceof Error ? error.message : String(error)}\nAlready updated objects: []. Inspect before retrying.`;
    }
}
